import React from 'react'
import { Box, Button, Stack } from '@mui/material'
import { useSelector, useDispatch } from 'react-redux'
import { handleValidateCodevalue } from '../../Utility/constant'
import DataGridTable from '../../Components/DataGrid'
import { useEmailConfig, getEmailConfigColumns, FolderSelectDropdown } from '../../Components/EmailConfig'
import { StyledFlexStart, StyledSubHeader } from '../../Components/Styled'
import { requestShowLoader, requestHideLoader } from '../../Store/Global/action'

const PROMOTIONAL_FROM = 'PROMOTIONAL_FROM';
const PROMOTIONAL_REPLY_TO = 'PROMOTIONAL_REPLY_TO';

const ClientEmailSettings = () => {
    const specificRolePermission = useSelector(state => state?.owner?.rolebasedData);
    const dispatch = useDispatch();

    const currentUser = useSelector(state => state?.owner?.currentuser);
    const {
        isLoading,
        internationalise,
        fromDataGridData,
        fromRowModesModel,
        handleFromEditClick,
        handleFromSaveClick,
        handleFromCancelClick,
        processFromRowUpdate,
        replyToDataGridData,
        replyToRowModesModel,
        handleReplyToEditClick,
        handleReplyToSaveClick,
        handleReplyToCancelClick,
        sameAsFrom,
        handleSameAsFromChange,
        replyToSelectedFolders,
        replyToAvailableFolders,
        replyToFoldersLoading,
        handleReplyToFolderChange,
        processReplyToIMapRowUpdate,
        saveReplyToImapConfig,
    } = useEmailConfig({
        selectedUser : currentUser,
        getUrl: 'api/client/email-config',
        saveUrl: 'api/client/email-config',
        fromType: PROMOTIONAL_FROM,
        replyToType: PROMOTIONAL_REPLY_TO,
    });

    const fromColumns = getEmailConfigColumns({
        rowModesModel: fromRowModesModel,
        handleEditClick: handleFromEditClick,
        handleSaveClick: handleFromSaveClick,
        handleCancelClick: handleFromCancelClick,
        internationalise,
        canEdit: specificRolePermission?.isNotificationManage,
    });

    const replyToColumns = getEmailConfigColumns({
        rowModesModel: replyToRowModesModel,
        handleEditClick: handleReplyToEditClick,
        handleSaveClick: handleReplyToSaveClick,
        handleCancelClick: handleReplyToCancelClick,
        internationalise,
        isIMap: true,
        canEdit: specificRolePermission?.isNotificationManage,
    });

    const handleSaveReplyToConfig = async () => {
        dispatch(requestShowLoader());
        await saveReplyToImapConfig();
        dispatch(requestHideLoader());
    };

    return (
            <Box sx = {{marginTop:"20px",height :  "470px"}}>
                <StyledSubHeader sx = {{pl : 2,paddingTop : "0px"}}>
                    {handleValidateCodevalue(internationalise, 'PROMO_FROM_TITLE') || 'Configure the email address that will appear as the sender for promotional/campaign emails sent to external recipients.'}
                </StyledSubHeader>
                <DataGridTable
                    height ='110px' 
                    rowModesModel={fromRowModesModel} 
                    columns = {fromColumns}
                    isRequiredToolBar={false}
                    isCheckboxReq = {false}
                    dataGridData={fromDataGridData}
                    handleProcessRowUpdate={processFromRowUpdate}
                    hideFooter={true}
                />

                {/* REPLY-TO Address Section */}
                
                <StyledFlexStart>
                   <StyledSubHeader  sx = {{pl : 2}}>
                        {handleValidateCodevalue(internationalise, 'PROMO_REPLY_TO_TITLE') || 'Configure the email address where replies to promotional/campaign emails will be received.'}
                    
                    {/* <FormControlLabel
                        control={
                            <Checkbox 
                            sx = {{paddingRight : 0}}
                                checked={sameAsFrom}
                                onChange={handleSameAsFromChange}
                                size="small"
                                disabled={!fromDataGridData[0]?.smtpHost}
                            />
                        }
                        label={handleValidateCodevalue(internationalise, 'COMMON_SAME_AS_FROM') || 'Same as FROM'}
                        sx={{ marginLeft: 0 }}
                    /> */}
                    </StyledSubHeader>
                </StyledFlexStart>
                
                <DataGridTable
                    height ='110px' 
                    rowModesModel={replyToRowModesModel} 
                    columns = {replyToColumns}
                    isRequiredToolBar={false}
                    isCheckboxReq = {false}
                    dataGridData={replyToDataGridData}
                    handleProcessRowUpdate={(newRow, oldRow) => processReplyToIMapRowUpdate(newRow, oldRow, 'api/client/email-config', '/test')}
                    hideFooter={true}
                />

                {/* Folder Selection for Reply-To */}
                <Stack direction="row" spacing={2} alignItems="flex-end" sx={{ pl: 2, mt: 2 }}>
                    <FolderSelectDropdown
                        selectedFolders={replyToSelectedFolders}
                        availableFolders={replyToAvailableFolders}
                        foldersLoading={replyToFoldersLoading}
                        onFolderChange={handleReplyToFolderChange}
                        disabled={!replyToDataGridData?.[0]?.imapHost || !specificRolePermission?.isNotificationManage}
                        internationalise={internationalise}
                        sx={{ width: "50%", marginBottom: 0 }}
                    />
                    {specificRolePermission?.isNotificationManage &&
                    <Button
                        className='biztantu-sec-btn'
                        variant="contained"
                        size="small"
                        onClick={handleSaveReplyToConfig}
                        disabled={!replyToDataGridData?.[0]?.imapHost}
                    >
                        {handleValidateCodevalue(internationalise, 'COMMON_SAVE') || 'Save'}
                    </Button>
                }
                </Stack>
            </Box>
    )
}

export default ClientEmailSettings
